import { createContext, useContext, useState } from "react";
import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { ErrorMessage, Spinner } from "app/components";
import { empresasService } from "app/services";

const ImportacionContext = createContext();

const initialState = {
  importacion_detalles: "",
  importacion_principal: false,
};

export function ImportacionProvider({ children }) {
  const params = useParams();

  const [importacion, setImportacion] = useState(initialState);
  const [isEditing, setEditing] = useState(false);

  const importacionQuery = useQuery({
    queryKey: [
      "empresa:get:importacion",
      params.empresa_id,
      params.importacion_id,
    ],
    queryFn: () =>
      empresasService.getImportacion({
        empresaId: params.empresa_id,
        importacionId: params.importacion_id,
      }),
    onSuccess: (data) => {
      setImportacion(data);
      setEditing(true);
    },
    enabled: !!params.importacion_id,
  });

  if (!!importacionQuery.isLoading && !!params.importacion_id) {
    return <Spinner label="Cargando la importación..." />;
  } else if (!!importacionQuery.isFetching && !!params.importacion_id) {
    return <Spinner label="Recuperando la importación..." />;
  } else if (!!importacionQuery.isRefetching && !!params.importacion_id) {
    return <Spinner label="Recargando la importación..." />;
  } else if (!!importacionQuery.isError) {
    return (
      <ErrorMessage message={importacionQuery.error.response.statusText} />
    );
  }

  return (
    <ImportacionContext.Provider
      value={{
        importacion,
        setImportacion,
        isEditing,
      }}
    >
      {children}
    </ImportacionContext.Provider>
  );
}

export function useImportacionContext() {
  const importacionContext = useContext(ImportacionContext);

  if (!importacionContext) {
    throw new Error(
      "useImportacionContext should be used inside the ImportacionProvider."
    );
  }

  return importacionContext;
}
